exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".account-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column; }\n  .account-container .account-menu {\n    flex: 1; }\n  .account-container .body-section {\n    overflow: auto; }\n", ""]);

